import {
  catchError,
  debounceTime,
  EMPTY,
  fromEvent,
  map,
  Subject,
  switchMap,
} from 'rxjs';
import { ErrorHandlingService } from './error-handling.service';
import { HttpService } from './api/http.service';
import { HttpHeaders } from '@angular/common/http';

class Auto_Complete {
  suggestions: any[] = [];
  usersObs$: any;
  currentPageScrolling: number = 1;
  pageSize: number = 100;
  searchQuery: any = null;
  loadScrollingData: boolean = false;
  searchQueryInEndPoint: boolean = false;
  searchBy: string = 'search_by_label';
  options: any = {};
  dynamicId: number = 0;
  baseEndPoint: string = '';
  shouldCallOnEmptyString: boolean = false;
  isGlobal: boolean = false;
  isStuffOnly: boolean = false;
  noData = false;
  suppressErrorToast: boolean = false;
  headers?: HttpHeaders;
  type?: string | number;
  wasSelected: boolean = false;
  onStateChange?: () => void;

  successCallback: Function = (res: any) => {
    if (this.returnNamesAsLabel) {
      return res?.data
        ? res?.data.map((result: any) => {
            return {
              ...result,
              label: `${result?.first_name} ${result?.last_name}`,
            };
          })
        : [];
    } else if (this.labelKey == 'dealer') {
      return res?.data
        ? res?.data.map((result: any) => {
            return {
              ...result,
              label: `${
                result?.third_party_info?.name || result?.dealer.business_name
              }`,
            };
          })
        : [];
    } else if (this.labelKey === 'third_party_info.third_party_name') {
      return res?.data
        ? res?.data.map((result: any) => {
            return {
              ...result,
              label: `${result?.third_party_info?.third_party_name}`,
            };
          })
        : [];
    } else {
      return res?.data ? res?.data : [];
    }
  };
  private querySubject = new Subject<any>();
  constructor(
    private _api: HttpService,
    private errHandle: ErrorHandlingService,
    public endpoint: string,
    public callOnEmptyString?: boolean | null,
    public claimCustomer?: boolean | null,
    private returnNamesAsLabel?: boolean | null,
    private searchKey?: string,
    private labelKey?: string
  ) {
    this.baseEndPoint = this.endpoint;
    this.shouldCallOnEmptyString = this.callOnEmptyString || false;
    this.preventEnterKeyBehaviour();

    this.querySubject
      .pipe(
        debounceTime(1000),
        switchMap((e) =>
          this.getData(e, this.isGlobal, this.isStuffOnly).pipe(
            catchError((err) => {
              if (!this.suppressErrorToast) {
                this.errHandle.errorHandling(err);
              }
              this.suggestions = [];
              this.noData = true;
              this.notifyStateChange();
              return EMPTY;
            })
          )
        )
      )
      .subscribe((res) => {
        if (this.wasSelected) return;
        this.suggestions = res?.data ? this.successCallback(res) : [];
        this.noData = !this.suggestions?.length;
        this.notifyStateChange();
      });
  }

  private notifyStateChange(): void {
    this.onStateChange?.();
  }

  preventEnterKeyBehaviour() {
    document.addEventListener('keydown', (event) => {
      if (
        event.key === 'Enter' &&
        (event?.target as any).nodeName !== 'TEXTAREA'
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    });
  }
  private updateEndpoint() {
    this.endpoint = `${this.baseEndPoint}/${this.dynamicId}`;
  }
  updateBaseEndpoint(newEndpoint: string) {
    this.baseEndPoint = newEndpoint;
    this.endpoint = `${this.baseEndPoint}`;
  }
  getData(e: any, isGlobal?: boolean, staffOnly?: boolean) {
    const encodedQuery = encodeURIComponent(e?.query);
    const separator = this.endpoint.includes('?') ? '&' : '?';
    if (this.searchQueryInEndPoint) {
      return this._api.getReq(
        `${this.endpoint}/${encodedQuery}${separator}page=${this.currentPageScrolling}&length=${this.pageSize}`,
        { params: this.options, headers: this.headers }
      );
    }
    if (this.claimCustomer || isGlobal) {
      return this._api.getReq(
        `${this.endpoint}${!!staffOnly ? '?' : '?filter_by_type=1'}&${
          this.searchKey ? this.searchKey : this.searchBy
        }=${encodedQuery}${!!staffOnly ? '&filter_by_group=1' : ''}`,
        { params: this.options, headers: this.headers }
      );
    }
    const filter = this.endpoint.includes('users')
      ? 'filter_by_group'
      : 'filter_by_type';

    return this._api.getReq(
      `${this.endpoint}${separator}page=${this.currentPageScrolling}&${
        this.searchKey ? this.searchKey : this.searchBy
      }=${encodedQuery}&length=${this.pageSize}${
        this.type
          ? `&${filter}=` + this.type + '&search=' + encodedQuery || ''
          : ''
      }`,
      { params: this.options, headers: this.headers }
    );
  }
  onQueryChange(e: any, type?: number | string) {
    this.wasSelected = false;
    this.searchQuery = e;
    this.currentPageScrolling = 1;
    this.noData = false;
    if (e?.query.trim() === '' && !this.shouldCallOnEmptyString) {
      this.suggestions = [];
      return;
    }

    if (e?.query?.length < 2 && !this.shouldCallOnEmptyString) {
      this.suggestions = [];
      return;
    }

    this.type = type;
    this.querySubject.next({ ...e, type });
  }
  paginationScrolling() {
    const content = document.querySelector('.p-autocomplete-panel');
    const scroll$ = fromEvent(content!, 'scroll').pipe(
      map(() => {
        return content!.scrollTop;
      })
    );

    scroll$.subscribe((scrollPos) => {
      let limit = content!.scrollHeight - content!.clientHeight;
      if (Math.ceil(scrollPos) === limit) {
        this.currentPageScrolling += 1;
        this.loadScrollingData = true;
        this.notifyStateChange();
        this.getData(this.searchQuery).subscribe(
          (res: any) => {
            this.loadScrollingData = false;
            let data = this.successCallback(res);
            this.suggestions = [...this.suggestions, ...data];
            this.notifyStateChange();
          },
          (error: any) => {
            this.loadScrollingData = false;
            this.errHandle.errorHandling(error);
            this.suggestions = [];
            this.notifyStateChange();
          }
        );
      }
    });
  }
  onSelected(e: any) {
    this.wasSelected = true;
    this.suggestions = [];
  }

  setDynamicId(dynamicId: number) {
    this.dynamicId = dynamicId;
    this.updateEndpoint();
  }
}

export { Auto_Complete };
